"use strict";
// import { useState } from 'react';
//
// export function useKeyDown() {
//   const [count, setCount] = useState(0)
//   const increment = () => setCount((c) => c + 1)
//   return { count, increment }
// }
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDown = void 0;
const react_1 = require("react");
/**
 * useKeyDown
 * @param {string, number} key - the name of the key to respond to, compared against event.key or event.keyCode
 * @param {function} action - the action to perform on key down
 * @param {boolean} active
 */
const useKeyDown = (key, action, active = true) => {
    (0, react_1.useEffect)(() => {
        const onKeyup = (e) => {
            if (!active)
                return;
            if (e.key === key || e.keyCode === key)
                return action === null || action === void 0 ? void 0 : action(e);
        };
        window.addEventListener('keydown', onKeyup);
        return () => window.removeEventListener('keydown', onKeyup);
    }, [action, key, active]);
};
exports.useKeyDown = useKeyDown;
//# sourceMappingURL=use-key-down.js.map